import React, { Fragment } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";

import Home from '../components/landing/Home';
import GeneralInformation from '../components/general/GeneralInformation';
import AeManagement from '../components/ae/AeManagement';
import AeManagementItem from '../components/ae/AeManagementItem';
import Post from '../components/post/Post';
import PostDetail from '../components/post/PostDetail';
import SearchResult from '../components/landing/SearchResult';
import Login from '../components/landing/Login';
import Register from '../components/landing/Register';
import Account from '../components/landing/Account';
import Terms from '../components/landing/Terms';
import Contact from '../components/landing/Contact';

export function RenderRoutes({ routes }) {
  return (
    <Routes>
      <Route path="/" key="ROOT" exact element={<Home urlKey="root" />} />
      <Route path="/general-information/dosage-and-administration" key="General Information" exact element={<GeneralInformation urlKey="ge" moduleType="dosage-and-administration" />} />
      <Route path="/general-information/overall-safety-profile" key="General Information" exact element={<GeneralInformation urlKey="ge" moduleType="overall-safety-profile" />} />
      <Route path="/special-warning" key="AE" exact element={<AeManagement urlKey="ae" moduleType="special-warning" />} />
      <Route path="/common-ars" key="AE" exact element={<AeManagement urlKey="ae" moduleType="common-ars" />} />
      <Route path="/ae-management/:module" key="AE" exact element={<AeManagementItem urlKey="ae" />} />
      <Route path="/case-sharing" key="post" exact element={<Post urlKey="case-sharing" postType="case" />} />
      <Route path="/case-sharing/:id" key="post" exact element={<PostDetail urlKey="case-sharing" postType="case" />} />
      <Route path="/past-conference-videos" key="post" exact element={<Post urlKey="past-conference-videos" postType="video" />} />
      <Route path="/past-conference-videos/:id" key="post" exact element={<PostDetail urlKey="past-conference-videos" postType="video" />} />
      <Route path="/slide-decks" key="post" exact element={<Post urlKey="slide-decks" postType="slide" />} />
      <Route path="/slide-decks/:id" key="post" exact element={<PostDetail urlKey="slide-decks" postType="slide" />} />
      <Route path="/news-and-updates" key="post" exact element={<Post urlKey="news-and-updates" postType="news" />} />
      <Route path="/news-and-updates/:id" key="post" exact element={<PostDetail urlKey="news-and-updates" postType="news" />} />
      <Route path="/searchResult/:word" key="Search" exact element={<SearchResult urlKey="search" />} />
      <Route path="/login" key="Member" exact element={<Login urlKey="member" />} />
      <Route path="/register" key="Member" exact element={<Register urlKey="member" />} />
      <Route path="/account" key="Member" exact element={<Account urlKey="member" />} />
      <Route path="/terms" key="Member" exact element={<Terms urlKey="terms" />} />
      <Route path="/contact" key="Member" exact element={<Contact urlKey="contact" />} />

      <Route element={() => <h1>Not Found!</h1>} />
    </Routes>
  );
}